import { Component, Input, Output, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { IMAGEVIEWER_CONFIG, ImageViewerConfig } from '@hallysonh/ngx-imageviewer';
import { CHttp } from '../services/chttp.service';
import { config } from '../../app.config';
import { AuthDataStorageService } from '../../auth/services/auth-data-storage.service';
import * as moment from 'moment';

declare var jQuery: any;

const MY_IMAGEVIEWER_CONFIG: ImageViewerConfig = {
  width: 566,
  height: 477,
  buttonStyle: {
    bgStyle: '#B71C1C', // custom container's background style
  },
};

@Component({
  selector: 'ch-offer-export-modal-dialog',
  templateUrl: './offer-export-modal-dialog.component.html',
  styleUrls: ['./offer-export-modal-dialog.component.css'],
  providers: [
    {
      provide: IMAGEVIEWER_CONFIG,
      useValue: MY_IMAGEVIEWER_CONFIG,
    },
  ],
})
export class OfferExportModalDialogComponent implements OnInit {
  @Input() public show: boolean;
  @Input() public data: any;
  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  @Output() public onExport: EventEmitter<any> = new EventEmitter();
  @ViewChild('modal') private modal;
  public loading: boolean;
  private period: any;
  private change: boolean;

  constructor(private http: CHttp, private authDataStorageService: AuthDataStorageService) {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.show) {
      this.change = true;
    }
  }

  ngAfterViewChecked() {
    if (this.change) {
      jQuery(this.modal.nativeElement)
        .modal({
          backdrop: false,
        })
        .on('hidden.bs.modal', e => {
          this.onClose.emit(e);
        });

      this.change = false;
    }
  }

  public datepickerChanged(value) {
    const startDateAsString = moment(value.start._d).format('YYYY-MM-DD');
    const endDateAsString = moment(value.end._d).format('YYYY-MM-DD');

    this.period = {
      start: startDateAsString,
      end: endDateAsString,
    };
  }

  public export() {
    if (!this.period) {
      return;
    }
    const data = {
      offerId: this.data.offerId,
      period: this.period,
    };
    this.onExport.emit(data);
    this.closeDialog();
  }

  private closeDialog() {
    jQuery(this.modal.nativeElement).modal('hide');
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/offer-export-modal-dialog/offer-export-modal-dialog.component.ts